// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fullscreenIcon_readings {\n    position: absolute !important;\n    top: 70px;\n    left: 0;\n    z-index: 10;\n}\n.HRVReadingCanvasYaxis {\n    width: 2px;\n    position: absolute;\n    left: 10;\n    top: 0;\n    height: 100%;\n}\n.HRVReadingCanvasYaxis:after {\n    content: \"Heart Rate\";\n    position: absolute;\n    transform: rotate(-90deg);\n    top: 50%;\n    left: -37px;\n    white-space: nowrap;\n    font-size: 20px;\n    font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
